
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Info, FileText } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const AboutUs = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Check if user is logged in (placeholder - implement actual logic later)
  const isLoggedIn = false;
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="container mx-auto px-4 py-8 flex-1">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-tax-deepBlue mb-8">About PropertyTaxHero.Com</h1>
          
          <section className="mb-10">
            <div className="flex items-center mb-4">
              <Info className="text-tax-brightBlue mr-2" />
              <h2 className="text-2xl font-semibold text-tax-deepBlue">Who We Are</h2>
            </div>
            <div className="prose prose-slate max-w-none">
              <p className="text-tax-neutralGray mb-4">
                <a href="https://propertytaxhero.com/">PropertyTaxHero.com</a> is a free public service created by MortgageNews.org to help homeowners 
                better understand and review their property tax assessments.
              </p>
              <p className="text-tax-neutralGray mb-4">
                Our goal is to make it easier to access public assessment data and help you determine if 
                your property may be overvalued.
              </p>
              <p className="text-tax-neutralGray mb-4">
                We believe that transparent information empowers better decisions—and our platform helps 
                homeowners, agents, and professionals save time and serve their communities.
              </p>
            </div>
          </section>
          
          <section className="mb-10">
            <div className="flex items-center mb-4">
              <FileText className="text-tax-brightBlue mr-2" />
              <h2 className="text-2xl font-semibold text-tax-deepBlue">100% Free, Always</h2>
            </div>
            <div className="prose prose-slate max-w-none">
              <ul className="list-disc pl-5 text-tax-neutralGray mb-4">
                <li className="mb-2">No fees, subscriptions, or upsells.</li>
                <li className="mb-2">We do not sell or share your information with third parties.</li>
                <li className="mb-2">We are ad-free and fully supported by MortgageNews.org as a public resource.</li>
              </ul>
            </div>
          </section>
          
          <section className="mb-10">
            <div className="flex items-center mb-4">
              <Info className="text-tax-brightBlue mr-2" />
              <h2 className="text-2xl font-semibold text-tax-deepBlue">Important Disclaimers</h2>
            </div>
            <div className="prose prose-slate max-w-none">
              <h3 className="text-lg font-medium text-tax-deepBlue mb-2">This tool is not a substitute for local expertise.</h3>
              <p className="text-tax-neutralGray mb-4">
                While our system can identify basic comparable properties, a licensed local real estate agent 
                is best equipped to assess unique features, remodeling, and neighborhood nuances.
              </p>
              
              {/* Agent reference section - displayed conditionally */}
              {window.location.search.includes('agentRef=') && (
                <div className="bg-tax-lightGray p-4 rounded-lg border border-tax-borderGray mb-6">
                  <h4 className="font-medium mb-2">You were invited courtesy of:</h4>
                  <div className="flex items-center">
                    {/* Placeholder for agent image and info */}
                    <div className="bg-gray-200 rounded-full w-12 h-12 mr-3"></div>
                    <div>
                      <p className="font-medium">Agent Name</p>
                      <p className="text-sm text-tax-neutralGray">Contact Info</p>
                    </div>
                  </div>
                </div>
              )}
              
              <h3 className="text-lg font-medium text-tax-deepBlue mb-2">We do not offer individual support.</h3>
              <p className="text-tax-neutralGray mb-4">
                This is a self-service platform. The data presented is pulled from public record sources 
                and third-party providers. We cannot edit or correct any property details.
              </p>
              
              <h3 className="text-lg font-medium text-tax-deepBlue mb-2">No legal advice.</h3>
              <p className="text-tax-neutralGray mb-6">
                This website does not constitute legal, tax, or real estate advice. For personalized guidance, 
                consult a licensed attorney, accountant, or real estate professional in your area.
              </p>
            </div>
          </section>
          
          <section className="mb-10">
            <div className="flex items-center mb-4">
              <FileText className="text-tax-brightBlue mr-2" />
              <h2 className="text-2xl font-semibold text-tax-deepBlue">Contact Info</h2>
            </div>
            <div className="prose prose-slate max-w-none">
              <p className="text-tax-neutralGray mb-2">PropertyTaxHero.Com is operated from:</p>
              <p className="text-tax-neutralGray mb-4">
                2205 136th Ave, Suite 105 #107<br />
                Broomfield, CO 80023
              </p>
              <p className="text-tax-neutralGray mb-6">
                Email for inquiries: <a href="mailto:dev@yourwayhome.com" className="text-tax-brightBlue hover:underline">dev@yourwayhome.com</a><br />
                Please note: We do not offer direct customer support.
              </p>
            </div>
          </section>
          
          {/* CTA only displayed when user is not logged in */}
          {!isLoggedIn && (
            <div className="mt-10 mb-6 text-center">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground">
                <Link to="/">Start your free property analysis →</Link>
              </Button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;
